// extracted by mini-css-extract-plugin
module.exports =  {"quickAddAddToCartButton":"PYj6h9"};